// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.wrapper[data-v-62e313c0] {\n  display: flex;\n  padding-top: 16px;\n  font-size: 14px;\n}\n.main[data-v-62e313c0] {\n  flex: 1;\n  min-height: calc(100vh - 260px);\n  background: #fff;\n  padding: 32px 32px 100px 32px;\n  margin-bottom: 20px;\n  position: relative;\n}\n.nav-wrap[data-v-62e313c0] {\n  margin-right: 8px;\n  min-width: 200px;\n}\n", ""]);
// Exports
module.exports = exports;
